import PropTypes from 'prop-types';
import React from 'react';
import { noop } from 'lodash';

import { LocaleService, UrlService } from '@sm360/widget-commons-core-services';
import { REDIRECTIONS } from '@sm360/widget-commons-general';
import { VEHICLE } from 'commons-vehicle/constants/vehicle.js';
import VehicleModel from 'commons-vehicle/Vehicle/models/VehicleModel.js';

import 'commons-vehicle/Vehicle/components/CallToAction/PriceQuote/PriceQuoteCTA.scss';

const PriceQuoteCTA = ({ vehicle, buttonClass, alternativeLabel, iconClass, onClick }) => {
    const locale = LocaleService.getSimpleLocale();
    const isVehicleNew = vehicle.vehicleConditionType === VEHICLE.CONDITIONS.NEW;
    let priceQuoteUrl = isVehicleNew ? REDIRECTIONS[locale].priceQuoteFormNew : REDIRECTIONS[locale].priceQuoteFormUsed;
    priceQuoteUrl = UrlService.replaceParamWithValue(priceQuoteUrl, '{make}', vehicle.make);
    priceQuoteUrl = UrlService.replaceParamWithValue(priceQuoteUrl, '{model}', vehicle.model);
    priceQuoteUrl = UrlService.replaceParamWithValue(priceQuoteUrl, '{year}', vehicle.year);
    priceQuoteUrl = UrlService.replaceParamWithValue(priceQuoteUrl, '{trim}', vehicle.modelTrim);
    priceQuoteUrl = UrlService.replaceParamWithValue(priceQuoteUrl, '{stock}', vehicle.stockNumber);
    priceQuoteUrl = UrlService.replaceParamWithValue(priceQuoteUrl, '{id}', vehicle.vehicleId);
    priceQuoteUrl = UrlService.replaceParamWithValue(
        priceQuoteUrl,
        '{trimId}',
        vehicle?.configuration?.smNewTrimCarId || vehicle.newCarTrimId
    );
    priceQuoteUrl = priceQuoteUrl.replace(/\s/g, '-');

    const currentClass = [buttonClass, 'vehicle-cta-btn'];
    return (
        <a href={priceQuoteUrl} className={currentClass.join(' ')} onClick={onClick}>
            {iconClass && <icon className={iconClass} />}
            <span>{alternativeLabel || LocaleService.t('CALL_TO_ACTION.BTN_PRICE_QUOTE_TEXT')}</span>
        </a>
    );
};

PriceQuoteCTA.defaultProps = {
    buttonClass: 'sr-button-1',
    alternativeLabel: null,
    iconClass: null,
    onClick: noop,
};

PriceQuoteCTA.propTypes = {
    vehicle: PropTypes.instanceOf(VehicleModel).isRequired,
    buttonClass: PropTypes.string,
    alternativeLabel: PropTypes.string,
    iconClass: PropTypes.string,
    onClick: PropTypes.func,
};

PriceQuoteCTA.displayName = 'PriceQuoteCTA';

export default PriceQuoteCTA;
